import React from "react"
import "./BedAllocationRequestComponent.scss"
import moment from "moment"
import PermissionUtils from "../../../../core/store/utils/PermissionUtils"

export default function BedAllocationRequestComponent({
  requests,
  history,
  userRole,
}: any) {
  return (
    <div className="bed-allocation-request-wrapper">
      <div className="d-flex header-section">
        <div className="header">Pending Bed Allocation Requests</div>
        <div className="view-all" onClick={() => history.push("/bedRequests")}>
          View All
        </div>
      </div>
      <div className="bed-allocation-list">
        {requests?.slice(0, 3)?.map((eachRequest: any) => (
          <div className="col-12 row m-0 each-bed-allocation">
            <div className="col-3 p-0">
              Patient Name:
              <b>{PermissionUtils.displayPatientName(
                userRole,
                eachRequest,
                true,
                null,
                null
              )}</b>
            </div>
            <div className="col-3 p-0">Service Name: <b> {eachRequest?.serviceName.join(', ')}</b></div>
            {eachRequest?.appointmentType === "IPD" ? <div className="col-3 p-0">Preffered Time: <b>{eachRequest?.bedPreference?.time}</b></div> : <div className="col-3 p-0">Consultant: <b>{eachRequest?.consultantName}</b></div>}
            <div className="col-2 p-0">
              Date: <b>{moment(eachRequest?.scheduleDate).format("DD-MM-YYYY")}</b>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
